export const triggerTaskPipelineTypes = [
  "trigger_linkedin_connection_request_accepted",
  "trigger_message_replied",
  "trigger_email_opened",
  "trigger_link_clicked",
  "trigger_website_page_visited",
] as const;

export const ruleTaskPipelineTypes = [
  "rule_ab_test",
  "rule_filter",
  "rule_manual_router",
] as const;

export type RuleTaskPipelineType = typeof ruleTaskPipelineTypes[number];

export const taskPipelineTypes = [
  ...triggerTaskPipelineTypes,
  ...ruleTaskPipelineTypes,
  "linkedin_send_connection_request",
  "linkedin_send_message",
  "linkedin_send_inmail",
  "linkedin_visit_profile",
  "linkedin_like_latest_post",
  "linkedin_comment_latest_post",
  "linkedin_endorse_skills",
  "linkedin_find_contact",
  "linkedin_withdraw_connection_request",
  "linkedin_enrich_profile",
  "email_send_message",
  "phone_call_phone",
  "integration_export_to_crm",
  "gs_add_tag",
  "gs_remove_tag",
  "gs_change_sender_profile",
  "gs_change_list",
  "gs_change_pipeline_stage",
  "gs_send_to_flow",
  "util_timer",
  "util_hodor",
  "end",
  "custom",
  "gs_trigger_custom_webhook",
  "gs_rotate_sender_profile",
  "gs_call_api",
] as const;

export type TaskPipelineType = typeof taskPipelineTypes[number];

export const getIsTaskPipelineType = (value: unknown): value is TaskPipelineType => {
  return taskPipelineTypes.includes(value as any);
};

export const taskPipelineTypeLabels: Record<TaskPipelineType, string> = {
  linkedin_send_connection_request: "Send connection request",
  linkedin_send_message: "Send message",
  linkedin_send_inmail: "Send InMail",
  linkedin_visit_profile: "Visit profile",
  linkedin_like_latest_post: "Like latest post",
  linkedin_comment_latest_post: "Comment latest post",
  linkedin_endorse_skills: "Endorse skills",
  linkedin_find_contact: "Find contact",
  linkedin_withdraw_connection_request: "Withdraw connection request",
  linkedin_enrich_profile: "Enrich profile",
  email_send_message: "Send email",
  phone_call_phone: "Phone call",
  integration_export_to_crm: "Export to CRM",
  gs_add_tag: "Add tag",
  gs_remove_tag: "Remove tag",
  gs_change_sender_profile: "Change sender profile",
  gs_change_list: "Change list",
  gs_change_pipeline_stage: "Change pipeline stage",
  gs_send_to_flow: "Send to automation",
  trigger_linkedin_connection_request_accepted: "Trigger: linkedin connection request accepted",
  trigger_message_replied: "Trigger: message replied",
  trigger_email_opened: "Trigger: email opened",
  trigger_link_clicked: "Trigger: link clicked",
  trigger_website_page_visited: "Trigger: website page visited",
  rule_ab_test: "A/B test",
  rule_filter: "Filter",
  rule_manual_router: "Manual router",
  util_timer: "Timer",
  util_hodor: "Hold",
  end: "Automation end",
  custom: "Custom",
  gs_trigger_custom_webhook: "Call Webhook",
  gs_rotate_sender_profile: "Rotate Sender Profile",
  gs_call_api: "Api Call",
};

export const executableTasksMap: Record<TaskPipelineType, boolean> = {
  linkedin_send_connection_request: true,
  linkedin_send_message: true,
  linkedin_send_inmail: true,
  linkedin_visit_profile: true,
  linkedin_like_latest_post: true,
  linkedin_comment_latest_post: true,
  linkedin_endorse_skills: true,
  linkedin_find_contact: true,
  linkedin_withdraw_connection_request: true,
  email_send_message: true,
  linkedin_enrich_profile: false,
  phone_call_phone: false,
  integration_export_to_crm: false,
  gs_add_tag: false,
  gs_remove_tag: false,
  gs_change_sender_profile: false,
  gs_change_list: false,
  gs_change_pipeline_stage: false,
  gs_send_to_flow: false,
  trigger_linkedin_connection_request_accepted: false,
  trigger_message_replied: false,
  trigger_email_opened: false,
  trigger_link_clicked: false,
  trigger_website_page_visited: false,
  rule_ab_test: false,
  rule_filter: false,
  rule_manual_router: false,
  util_timer: false,
  util_hodor: false,
  end: false,
  custom: false,
  gs_trigger_custom_webhook: false,
  gs_rotate_sender_profile: false,
  gs_call_api: false,
};

export const executableTaskTypes = taskPipelineTypes.filter((type) => executableTasksMap[type]);

